import React from 'react';
import PropTypes, { string } from 'prop-types';

const LegendFuture = ({ items }) => (
  <div className="line-chart-legend">
    {items.map((it, index) => {
      const key = index;

      return (
        <div key={key} className={`legend-item${it.classes} future`}>
          <span>{it.text}</span>
          <div className="legend-marker combined">
            <div className="line" style={{ backgroundColor: it.medianColor }} />
            <div className="box" style={{ backgroundColor: it.bandWidthColor }} />
          </div>
        </div>
      );
    })}
    <div className="legend-description future">
      Median 30-jähriges Mittel
      <br />
      Bandbreite 30-jähriges Mittel
    </div>
  </div>
);

LegendFuture.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      classes: string,
      text: string,
      color: string,
    }).isRequired
  ).isRequired,
};

export default LegendFuture;
